/**
 * Base models with common types and interfaces.
 */

export interface BaseEntity {
  id: string;
  created?: Date;
  updated?: Date;
}

export interface TimestampMixin {
  created?: Date;
  updated?: Date;
}

export interface SearchableEntity {
  keywords?: string[];
}

export interface ImageEntity {
  imageUrl?: string;
  storagePath?: string;
}

export interface ApprovalEntity {
  approvalState?: 'approved' | 'pending' | 'rejected';
}

export interface ActiveEntity {
  active?: boolean;
}

export interface ContactEntity {
  email?: string;
  mobile?: string;
  phone?: string;
}

export interface AddressEntity {
  address?: string;
  city?: string;
  municipality?: string;
  zone?: string;
  referencePoint?: string;
}

// Common field defaults
export const DEFAULT_STRINGS = {
  UNDEFINED: '',
  NOT_ASSIGNED: 'Not assigned',
  WITHOUT_DEFINITION: 'Without definition',
} as const;

export const DEFAULT_NUMBERS = {
  ZERO: 0,
  MIN_QUANTITY: 1,
} as const;

export const DEFAULT_BOOLEANS = {
  TRUE: true,
  FALSE: false,
} as const;
